module.exports = __webpack_public_path__ + "img/ata.cbb9841b.svg";